<template>
	<div class="loader" :class="type">
		<transition name="ring" appear>
			<div class="lds-ring">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: "PageLoader",
	props: {
		type: {
			type: String,
			default: ''
		}
	}
}
</script>

<style scoped lang="sass">
.loader
	position: fixed
	inset: 0
	z-index: 10000
	display: flex
	align-items: center
	justify-content: center
	backdrop-filter: blur(4px)
	&::before
		content: ''
		position: absolute
		inset: 0
		background-color: white
		opacity: 0.25
	&.absolute
		position: absolute
.lds-ring
	position: relative
	display: inline-block
	width: 80px
	height: 80px

	div
		position: absolute
		display: block
		width: 64px
		height: 64px
		margin: 5px
		border: 5px solid #93C11C
		border-color: #93C11C transparent transparent transparent
		border-radius: 50%
		box-sizing: border-box
		animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite

		&:nth-child(1)
			animation-delay: -0.45s

		&:nth-child(2)
			animation-delay: -0.3s

		&:nth-child(3)
			animation-delay: -0.15s

.ring-enter-active, .ring-leave-active
	transition: transform .3s ease .3s

.ring-enter-from
	transform: scale(.75)

.ring-leave-to
	transform: scale(.85)


@keyframes lds-ring
	0%
		transform: rotate(0deg)
	100%
		transform: rotate(360deg)

</style>
